// MARK: used in v2
export const REASON_NOT_AVAILABLE_MAPPING: Record<string, string> = {
  out_of_stock: "Out of stock",
  pre_order_only: "Pre-order only",
}

export const DEFAULT_STOREFRONT =
  process.env.GATSBY_SHOP_STOREFRONT_NAME || "shop"
